import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/site/SmoothScroll";
import AuthCallback from "@/components/site/AuthCallback";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import ProductPage from "@/pages/ProductPage";
import PartnersIndex from "@/pages/PartnersIndex";
import PartnerPage from "@/pages/PartnerPage";

function Shell() {
  const location = useLocation();
  // Returning from Emergent Google OAuth: exchange session before anything else.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <SmoothScroll />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/partners" element={<PartnersIndex />} />
        <Route path="/partners/:slug" element={<PartnerPage />} />
        <Route path="/cubemars" element={<Navigate to="/partners/cubemars" replace />} />
        <Route path="/product/:slug" element={<ProductPage />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
        <Toaster position="top-right" theme="dark" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
